<template>
  <!-- 套餐剩余次数 -->
  <div>
    <el-row>
        <!-- 工具条 -->
        <el-form
          :inline="true"
          :model="formInline"
          class="demo-form-inline toolbar"
          style="padding-bottom: 0px"
          @submit.native.prevent
        >
          <el-form-item label="长者姓名">
            <el-input
              clearable
              v-model.trim="formInline.oldName"
              placeholder="请输入长者姓名"
              @keyup.enter.native.prevent="enterSearchMember"
            ></el-input>
          </el-form-item>
          <!-- <el-form-item label="长者电话">
            <el-input
              clearable
              v-model.trim="formInline.oldPhone"
              placeholder="请输入长者电话"
              @keyup.enter.native.prevent="enterSearchMember"
            ></el-input>
          </el-form-item> -->
          <el-form-item label="性别">
            <el-select v-model="formInline.sex" style="width: 120px" clearable>
              <el-option value="0" label="男"></el-option>
              <el-option value="1" label="女"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button
              type="primary"
              icon="el-icon-search"
              @click="search"
              plain
              >查询</el-button
            >
          </el-form-item>
        </el-form>
        <el-table
          style="width: 100%"
          :data="tableData"
          v-loading="tableLoading"
          :header-cell-style="{
            'text-align': 'center',
            'font-size': '16px',
            'font-weight': '600',
             color: '#2d2d2d',
            'background-color': '#d4f5fa',
          }"
          :cell-style="{ 'text-align': 'center', 'font-size': '16px' }"
          :row-style="tableRowStyle"
        >
          <el-table-column
            prop="oldName"
            label="长者姓名"
            min-width="100"
          ></el-table-column>
          <el-table-column
            prop="oldPhone"
            label="联系电话"
            min-width="120"
          ></el-table-column>
          <el-table-column
            prop="oldIdCard"
            label="身份证号"
            min-width="200"
          ></el-table-column>
          <el-table-column
            prop="sex"
            label="性别"
            min-width="80"
          ></el-table-column>
          <el-table-column
            prop="oldAddress"
            label="家庭住址"
            min-width="300"
          ></el-table-column>
          <el-table-column label="操作" min-width="120">
            <template slot-scope="scope"> 
              <a @click="handleDetail(scope.$index, scope.row)" class="curcor" style="margin-left:20px">
                <img
                  class="handedness"
                  src="@/assets/beadhouse/chakan_icon.png"
                />
              </a>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          background
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          layout="total, prev, pager, next"
          :total="totalDataNumber"
          :page-size="pageSize"
          align="center"
          class="fenye"
        >
        </el-pagination>
        <!-- 报表上传 -->
      <el-dialog
        title="长者套餐剩余服务次数"
        width="40%"
        :visible.sync="showDialog"
        :close-on-click-modal="false">
        <el-row type="flex" justify="center">
          <el-table
              :data="showServiceList"
              style="width: 95%; margin: 0 auto" >
              <el-table-column label="服务项目" prop="name"></el-table-column>
              <el-table-column label="单价" prop="price"></el-table-column>
              <el-table-column label="剩余次数" prop="num"></el-table-column>
            </el-table>
        </el-row>
        <div slot="footer" class="dialog-footer" align="center">
          <el-button type="primary" @click.native="showDialog = false">关闭</el-button>
        </div>
      </el-dialog>
    </el-row>
  </div>
</template>
<script>
import bus from "@/vuex/eventBus"; //引入eventBus,接收子界面传递的跳转指令,然后在父界面跳转,添加tab
export default {
  name: "OldServiceTime",
  data() {
    return {
      formInline: {
        oldName: ""
      },
      tableData: [], //表格数据
      tableLoading: false, //表格加载的loading
      /* 分页的 */
      currentPage: 1, //初始页
      showDialog:false,
      allServiceList:[],
      showServiceList:[], //长者服务项目剩余次数
      pageNo: 1, //页码
      pageSize: 10, //每页显示的条数
      totalDataNumber: 0, //数据的总数,
      formSelect: [
        {
          label: "男",
          value: "0",
        },
        {
          label: "女",
          value: "1",
        },
      ],
      fieldsVisisble: false,
      oldNameOptions: [], // 老人姓名集合
    };
  },
  methods: {
    //修改table tr行的背景色
    tableRowStyle({ row, rowIndex }) {
      if (rowIndex % 2 == 0) {
        return "background-color: #ffffff";
      } else {
        return "background-color: #e4f5f8";
      }
    },
    formatTime: function (row) {
      if (row.registryTime != null) {
        return row.registryTime;
      } else {
        var date = new Date(row.createTime)
        var Y = date.getFullYear()
        var M = date.getMonth() + 1
        var D = date.getDate()
        return Y + '-' + (M < 10 ? '0' + M : M) + '-' + (D < 10 ? '0' + D : D)
      }
    },
    /*
      点击查询
    */
    search() {
      this.queryOldman(
          this.formInline.oldName,
          (this.pageNo = 1),
          (this.pageSize = 10)
        );
    },

    /*
      键盘事件 按下键盘回车 查询
    */
    enterSearchMember(e) {
      var keyCode = window.event ? e.keyCode : e.which;
      if (keyCode == 13 && this.formInline.oldName != null) {
        this.search();
      }
    },
    handleDetail(index, row) {
      this.showDialog = true;
      this.$postForm("omc/servicePackage/queryServiceOldNum", {
        oldmanId:row.oldmanId
      }).then(res =>{
          res.result.forEach(item =>{
            this.allServiceList.forEach(item2 =>{
              if(item.serviceId == item2.id){
                item.name = item2.serviceName;
                item.price = item2.integral;
              }
            })
          })
          this.showServiceList = res.result;
      })
    },
    /*
      查询老人分页列表
    */
    queryOldman() {
      // console.log(this.formInline.status == "0");
      let params = {};
      if (this.formInline.oldName != "" || null || undefined) {
        params.oldName = this.formInline.oldName;
      }
      params.pageNo = String(this.pageNo);
      params.pageSize = String(this.pageSize);
      this.tableData = [];
      this.tableLoading = true;
      this.$postJson("omc/Oldman/quickShowAllOldMan", params).then((res) => {
        if (res.code == 200) {
          if (res.result.list != null) {
            this.pageSize = res.result.pageSize;
            this.currentPage = res.result.pageNum;
            this.totalDataNumber = res.result.total * 1;
            res.result.list.forEach((item) => {
              var object = {};
              object = Object.assign({}, item);
              object.sex = item.sex == 0 ? "男" : "女";
              this.tableData.push(object);
            });
          } else {
            this.tableData = [];
            this.pageSize = 10;
            this.currentPage = 1;
            this.totalDataNumber = 0;
          }
        } else {
          this.tableData = [];
          this.pageSize = 10;
          this.currentPage = 1;
          this.totalDataNumber = 0;
        }
        setTimeout(() => {
          this.tableLoading = false;
        }, 500);
      });
    },
    /*
      当前页变化
    */
    handleCurrentChange(val) {
      // console.log(`当前页: ${val}`);
      this.pageNo = val;
      this.queryOldman(); //刷新套餐列表的数据
    },
    getAllService(){
      this.$postJson("omc/service/queryListWithPage", {
        pageNum: 1,
        pageSize: 999
      }).then(res =>{
        this.allServiceList = res.result.list;
      })
    },
  },
  mounted() {
    this.queryOldman();
    this.getAllService();

  },
};
</script>
<style lang="scss" scoped>
::deep .el-dialog__header {
  height: 19px !important;
  text-align: left;
}
::deep .el-dialog__footer {
  text-align: center;
}
.fenye {
  margin: 0;
  padding: 30px 0;
  background: #fff;
}
</style>
